import { Button, Card, Heading, Text } from "@/design-system";

type BlogCtaProps = {
  /** Abre o formulário de demo da página do post (o mesmo do bloco `cta-lead`). */
  onOpenDemo: () => void;
};

/**
 * Caixa de conversão do blog.
 *
 * Usa a mesma linguagem do bloco `cta-lead` que aparece dentro dos posts
 * (`globals.css`): fundo `ds-brand-50`, borda de 1px em `ds-brand-500` (3,30:1,
 * acima do mínimo de 3:1 para limite de componente) e botão sólido
 * `ds-brand-600` + `ds-on-solid` (4,91:1). O bloco escuro de antes competia
 * com o artigo e não era vocabulário da marca.
 *
 * Contraste: título `ds-ink-900` sobre `ds-brand-50` = 16,46:1; apoio
 * `ds-ink-700` = 8,99:1.
 *
 * O botão abre o formulário de demo em vez de levar ao WhatsApp: o lead chega
 * com nome, rede e tamanho, e o contato continua sendo pelo WhatsApp.
 */
export const BlogCta = ({ onOpenDemo }: BlogCtaProps) => (
  // Sem `id` no título: a página do post monta duas instâncias (uma no fluxo
  // do celular, outra na coluna lateral do desktop) e um `id` fixo se
  // duplicaria no DOM.
  <Card
    className="border-ds-brand-500 bg-ds-brand-50 my-10 flex flex-col gap-3"
  >
    <Heading level={2} size={4}>
      Reduza a inadimplência do seu crediário com a Fidexa
    </Heading>
    <Text size="small" tone="muted" className="max-w-prose">
      Automatize sua régua de cobrança via WhatsApp, recupere créditos e tenha visibilidade
      total da carteira, tudo em um só painel.
    </Text>
    <Button fullWidth className="mt-1 sm:w-auto" onClick={onOpenDemo}>
      {/* Rótulo curto de propósito: o botão vive numa coluna de 320px no
          desktop, e o `Button` é `whitespace-nowrap` — texto longo vaza do
          cartão. */}
      Fale com um especialista
    </Button>
  </Card>
);
